import { useEffect } from 'react';

const SitemapRedirect = () => {
  useEffect(() => {
    const reactAppApiUrl = process.env.REACT_APP_API_URL;
    if (!reactAppApiUrl) {
      console.error('REACT_APP_API_URL is not set');
      return;
    }

    const apiUrl = new URL('api/sitemap/', reactAppApiUrl).toString();

    // Redirect the browser to the XML URL
    window.location.href = apiUrl;
  }, []);

  return <div>Przekierowywanie do mapy witryny...</div>;
};

export default SitemapRedirect;